import Component from "../../lib/component";
import promocodeSvg from "./assets/promocode.svg";

export const PromocodeConfig = {
  componentTypeKey: "Promocode",
  baseHtmlClass: "promocode",
  selector: ".promocode",

  datasetConfigKey: "promocode__config",
  codeBaseHtmlClass: "promocode__code",
  svgBaseHtmlClass: "promocode__svg",
};

export class Promocode extends Component {
  static get config() {
    return PromocodeConfig;
  }

  constructor(id_or_element) {
    super({
      element: id_or_element,
      config: Promocode.config,
    });

    this.setDatasetConfig(Promocode.config.datasetConfigKey);
    this.code = this.getDatasetConfigValue("code");

    this.renderInitial();
    this.render();
  }

  renderInitial() {
    if (this.hasCode()) {
      this.element.style.display = null;
      const codeHtml = `<div class="${PromocodeConfig.codeBaseHtmlClass}">${this.code}</div>`;
      const svgHtml = `<div class="${PromocodeConfig.svgBaseHtmlClass}">${promocodeSvg}</div>`;
      this.element.innerHTML = `${svgHtml}${codeHtml}`;
    }
  }

  render() {}

  hasCode() {
    return this.code && this.code.length > 0;
  }
}
